import { css } from "lit";

export default css`
    .player {
        display: block;
        position: absolute;
        width: 50px;
        height: 50px;
        bottom: 20px;
        background-image: url("assets/img/minigames/dragoninvaders/wizard.png");
        background-repeat: no-repeat;
        background-size: cover;
    }
`;